import { render, staticRenderFns } from "./ContinuousStudyCA.vue?vue&type=template&id=2dde71e1&scoped=true&"
import script from "./ContinuousStudyCA.vue?vue&type=script&lang=js&"
export * from "./ContinuousStudyCA.vue?vue&type=script&lang=js&"
import style0 from "./ContinuousStudyCA.vue?vue&type=style&index=0&id=2dde71e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dde71e1",
  null
  
)

export default component.exports